import React from "react";

const SEO = ({ title }) => {
  return (
    <>
      <meta charSet="utf-8" />
      <title>Moftah Solutions || {title}</title>
      <meta name="robots" content="noindex, follow" />
      <meta
        name="description"
        content={"Moftah Solutions || " + title}
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
    </>
  );
};

export default SEO;
